<template>
<div>
  Limited to 10
  <md-card v-for="(standard, idx) in standards" :key="idx">
      <md-card-header>
        <div class="md-title">{{ standard.subject }} | {{standard.grade}}</div>
        <div class="md-subhead">{{ standard.benchmark_number }}</div>
      </md-card-header>
      <p class="card-text">{{standard.description}}</p>
      <div class="card-footer text-muted">{{standard.idea_standard}}</div>  
  </md-card>
</div>
</template>

<script>
// @ is an alias to /src
import { db } from '../main'
export default {
  name: 'standards-list',
  created() {
    this.$docTitle = 'Standards list'
  },
  data() {
    return {
      standards: []
    }
  },
  firestore() {
    return {
      standards: db.collection('standards').limit(10)
    }
  }
}
</script>
<style lang="css" scoped>
  .md-card {
    max-width: 600px;
    margin: 4px;
    display: block;
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// src/views/StandardsList.vue